import { useEffect, useState } from "react"
import LocalSearch from "../../components/UI/Search/Search"
import Add from '@material-ui/icons/Add'
import Button from "../../components/UI/Button/Button"
import fetchData from "../../shared/fetchData"
import SelectBox from "../../components/UI/Select/Select"
import KioskUnit from "../../components/KioskUnit/KioskUnit"
import ReactPaginate from 'react-paginate'
import { Collapse } from "@material-ui/core"
import KioskUnitForm from "../../components/KioskUnit/KioskUnitForm"
import * as FileSaver from "file-saver"
import * as XLSX from "xlsx"


const KioskUnits = () => {
    const [loading, setLoading] = useState(false)
    const [offset, setOffset] = useState(1)
    const [perPage, setPerPage] = useState(3)
    const [pageCount, setPageCount] = useState(0)
    const [permission, setPermission] = useState(window.localStorage.getItem("permission"))
    const [kioskUnits, setKioskUnits] = useState([]);
    const [kiosks, setKiosks] = useState([])
    const [kiosk, setKiosk] = useState('')
    const [units, setUnits] = useState([])
    const [unit, setUnit] = useState('')
    const [kioskUnit, setKioskUnit] = useState('');
    const [edit, setEdit] = useState(false);
    const [showKioskUnitForm, setShowKioskUnitForm] = useState(false);

    useEffect(() => {
        setLoading(true)
        var raw = JSON.stringify({
            "pl": "10000",
            "pn": "1",
            "version": "mtpx001"
        })
        var url = 'management/api/v1/units/getUnits'
        fetchData(raw, url).then(response => response.json())
            .then(result => {
                setUnits(result.units)
            })
            .catch(error => setLoading(false))
        var url = 'management/api/v1/kiosks/getKiosks'
        fetchData(raw, url).then(response => response.json())
            .then(result => {
                setKiosks(result.kiosks)
            })
            .catch(error => setLoading(false))
        var raw = JSON.stringify({
            "pl": perPage,
            "pn": offset,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/kioskunits/getKioskUnits'
        fetchData(raw, url).then(response => response.json())
            .then(result => {
                setKioskUnits(result.kioskUnits)
                setPageCount(result.count / parseInt(perPage))
                setLoading(false)
            })
            .catch(error => console.log(''))
    }, []);

    const changeUnit = (selectedOption) => {
        setUnit(selectedOption);
    }

    const changeKiosk = (selectedOption) => {
        setKiosk(selectedOption);
    }

    const search = () => {
        var raw = JSON.stringify({
            kioskUnit: {
                unitId: !!unit && unit != '' ? unit.value : '',
                kioskId: !!kiosk && kiosk != '' ? kiosk.value : '',
            },
            "pl": perPage,
            "pn": offset,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/kioskunits/getKioskUnits'
        fetchData(raw, url).then(response => response.json())
            .then(result => {
                setKioskUnits(result.kioskUnits)
                setPageCount(result.count / parseInt(perPage))
            })
            .catch(error => console.log(''))
    }

    const refresh = () => {
        setOffset(1);
        var raw = JSON.stringify({
            "pl": perPage,
            "pn": "1",
            "version": "mtpx001"
        })
        var url = 'management/api/v1/kioskunits/getKioskUnits'
        fetchData(raw, url).then(response => response.json())
            .then(result => {
                setUnit('');
                setKiosk('');
                setKioskUnits(result.kioskUnits)
                setPageCount(result.count / parseInt(perPage))
            })
            .catch(error => console.log(''))
    }
    const handlePageClick = (e) => {
        setOffset(e.selected + 1)
        var raw = JSON.stringify({
            kioskUnit: {
                unitId: !!unit && unit != '' ? unit.value : '',
                kioskId: !!kiosk && kiosk != '' ? kiosk.value : '',
            },
            "pl": perPage,
            "pn": e.selected + 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/kioskunits/getKioskUnits'
        setLoading(true)
        fetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    setPageCount(result.count / parseInt(perPage))
                    setKioskUnits(result.kioskUnits)
                }
            })
            .catch(error => setLoading(false))
    }

    const editKioskUnit = (event, id) => {
        const kioskUnt = kioskUnits.filter(k => k.id === id);
        if (!!kioskUnt && kioskUnt.length != 0) {
            setKioskUnit(kioskUnt[0]);
            setEdit(true);
            setShowKioskUnitForm(true);
        }
    }

    const addNewKioskUnit = (event, id) => {
        setKioskUnit('');
        setEdit(false);
        setShowKioskUnitForm(true);
    }

    const exportToCSV = (event) => {
        const token = window.localStorage.getItem("token")
        var raw = JSON.stringify({
            "kioskUnit": {
                unitId: !!unit && unit != '' ? unit.value : '',
                kioskId: !!kiosk && kiosk != '' ? kiosk.value : '',
            },
            "pl": "1048576",
            "pn": "1",
            "version": "mtpx001"
        })
        var url = 'management/api/v1/kioskunits/getKioskUnits'
        setLoading(true)
        fetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    let exportOrderReport = []
                    let count = 0
                    const orderReport = result.kioskUnits.map(o => {
                        count++
                        exportOrderReport.push({
                            'ردیف': count,
                            'نام لاکر': o.kioskDescription,
                            'حساب': o.unitDescription,
                            "تعداد": o.maxCount,
                        })
                    })
                    const fileType =
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                    const fileExtension = ".xlsx";
                    const ws = XLSX.utils.json_to_sheet(exportOrderReport);
                    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                    const data = new Blob([excelBuffer], { type: fileType });
                    FileSaver.saveAs(data, 'lockerUnits' + fileExtension)
                }
            })
            .catch(error => setLoading(false))
    }

    let unitList = []
    if (units != null && units.length != 0) {
        units.map(z => {
            unitList.push({
                value: z.id,
                label: z.unitName
            })
        })
    }

    let kioskList = []
    if (kiosks != null && kiosks.length != 0) {
        kiosks.map(z => {
            kioskList.push({
                value: z.id,
                label: z.description
            })
        })
    }
    let form = <div>
        <div className="row pl-4" dir="ltr" style={{ height: '0px' }}>
            <Button btnType="Refresh" clicked={refresh}></Button>
        </div>
        <div className="row mt-4">
            <SelectBox
                name="form-field-name"
                value={unit}
                placeholder="حساب"
                options={unitList}
                onChange={changeUnit}
                col="4 mt-2"
            />
            <SelectBox
                name="form-field-name"
                value={kiosk}
                placeholder="لاکر"
                options={kioskList}
                onChange={changeKiosk}
                col="4 mt-2"
            />
        </div>
        <div className="row text-left" dir="ltr">
            <div className="col-2">
                <Button btnType="search-btn" clicked={search}>جستجو</Button>
            </div>
            <div className="col-2">
                <Button btnType="Search" clicked={exportToCSV}>
                    <span className="tab-color">
                        گزارشگیری
                    </span>
                </Button>
            </div>
        </div>
    </div>


    const kioskUnitList = kioskUnits != null && kioskUnits.length != 0 ? kioskUnits.map(l => {
        return (<KioskUnit edit={editKioskUnit} reload={search} data={l} />)
    }) : ''

    return (
        <>
            <Collapse in={!showKioskUnitForm} >
                <LocalSearch class="orders-search" form={form} />

                <div className="row justify-content-center mt-3">
                    <div className="col-10">
                        <div onClick={addNewKioskUnit} className="Add">
                            <Add className="UserIcon" />
                        </div>
                    </div>
                </div>
                {kioskUnitList}
                {kiosks != null && kiosks.length != 0 ?
                    <div className="row justify-content-center">
                        <ReactPaginate
                            previousLabel={"→قبلی"}
                            nextLabel={"بعدی←"}
                            forcePage={offset >= 0 ? offset - 1 : offset}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageClick}
                            containerClassName="pagination"
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"} />
                    </div>
                    : ''}
            </Collapse>
            <Collapse in={showKioskUnitForm} >
                <KioskUnitForm reload={() => { setShowKioskUnitForm(false); search(); }} back={() => { setShowKioskUnitForm(false); }} edit={edit} kioskUnit={kioskUnit} />
            </Collapse>
        </>
    )
}

export default KioskUnits;